import React from 'react';
import CartProduct from './CartProduct';

const MerchantGroup = ({ 
  merchantId, 
  group, 
  handleDelete, 
  handleQuantityChange,
  currency
}) => {
  const merchant = group.products[0]?.merchant;
  const merchantName = merchant?.username || 'Unknown';
  const merchantInfo = merchant?.merchantInfo || {};
  const storeName = merchantInfo.storeName || merchantName;
  const initials = storeName
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase();
  const deliveryMethod = group.deliveryMethod || 'shipping';

  // Function to format delivery method for display
  const formatDeliveryMethod = (method) => {
    return method.charAt(0).toUpperCase() + method.slice(1);
  };

  return (
    <div
      key={merchantId}
      className='bg-white rounded-lg shadow-sm mb-8 overflow-hidden'
    >
      {/* Merchant Header */}
      <div className='p-6 border-b border-gray-200'>
        <div className='flex items-center justify-between'>
          <div className='flex items-center'>
            <div className='w-12 h-12 rounded-full overflow-hidden flex items-center justify-center bg-brand-teal text-white'>
              {merchant?.profilePic?.[0]?.url ? (
                <img
                  src={merchant.profilePic[0].url}
                  alt={storeName}
                  className='w-full h-full object-cover'
                />
              ) : (
                <span className='text-lg font-bold'>{initials}</span>
              )}
            </div>
            <div className='ml-4'>
              <h3 className='text-lg font-medium'>{storeName}</h3>
              {merchantInfo.storeDetail?.description && (
                <p className='text-sm text-gray-500'>
                  {merchantInfo.storeDetail.description}
                </p>
              )}
            </div>
          </div>
          
          {/* Delivery Method Badge */}
          <div className='ml-4'>
            <span className={`px-3 py-1 rounded-full text-sm ${deliveryMethod === 'pickup' ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'}`}>
              {formatDeliveryMethod(deliveryMethod)}
            </span>
          </div>
        </div>
      </div>

      {/* Products */}
      <div className='divide-y divide-gray-200'>
        {group.products.map(product => {
          const isOutOfStock = product.stock === '0';
          return (
            <CartProduct 
              key={`${product.cartItemId || product.id}-${product.type}`}
              product={product}
              handleDelete={handleDelete}
              handleQuantityChange={handleQuantityChange}
              isOutOfStock={isOutOfStock}
              currency={currency || product.currency || 'USD'}
            />
          );
        })}
      </div>
    </div>
  );
};

export default MerchantGroup; 